import { defineStore } from "pinia";
import apiSkobo from "@/helpers/api/apiSkobo";
import axios from "axios";

export const useMeStore = defineStore("me", {
  state: () => {
    return {
      meProfile: {},
      profileForModule: {},
      isCustomerAdminTemporary: undefined,
      sessionToken: null
    };
  },

  actions: {
    async loadMe(me) {
      this.meProfile = me;
    },

    async loadMyProfileForModule(moduleName) {
      if (!this.profileForModule[moduleName]) {
        const response = await apiSkobo.get(`/me/profile/${moduleName}`);
        this.profileForModule[moduleName] = response.data.value;
      }
      return this.profileForModule[moduleName];
    },

    async loadTemporaryCustomerAdmin() {
      if (this.isCustomerAdminTemporary === undefined) {
        const result = await axios
          .get(
            `https://skobostats.azurewebsites.net/api/CustomerAdminUsers?code=yM9fHa3JpYaEdBvlweQhgQXcy1/JJoS2fWgibebr9afujxzuufHk4w==&pi=${this.userId}`
          )
          .catch(() => {
            return false;
          });

        if (result.status === 200) {
          this.isCustomerAdminTemporary = true;
        }
        this.isCustomerAdminTemporary = false;
      }
      return this.isCustomerAdminTemporary;
    },

    logEvent(endpoint) {
      apiSkobo.post("/log", {
        endpoint
      });
    }
  },

  getters: {
    profile: state => state.meProfile,
    userId: state => state.meProfile?.userId || null,
    extSysApiUserId: state => state.meProfile?.extSysApiUserId || null,
    emailSchoolAddress: state => state.meProfile?.emailSchoolAddress || "",

    isTeacher: state => state.meProfile?.roles?.includes("Teacher") || false,
    isStudent: state => state.meProfile?.roles?.includes("Student") || false,
    isSuperuser: state => state.meProfile?.roles?.includes("SuperUser") || false,

    isConfidentialTeacher: state => state.meProfile?.roles?.includes("ConfidentialTeacher") || false,
    isConfidentialLeader: state => state.meProfile?.roles?.includes("ConfidentialLeader") || false,
    hasRole: state => role => state.meProfile?.roles?.includes(role) || false,

    highestRole: state => {
      if (state.meProfile?.roles?.includes("SuperUser")) {
        return "SuperUser";
      }
      if (state.meProfile?.roles?.includes("Teacher")) {
        return "Teacher";
      }
      if (state.meProfile?.roles?.includes("Student")) {
        return "Student";
      }
      return "";
    },

    permissionHasEditSections: state => state.meProfile?.permission?.sectionsEdit === true || false
  }
});
